import {get} from './base.service'
import {post} from './base.service'

export default {
    /* 获取住院登记信息*/
    loadDetail(params){
        return get('/app/inpatient/checkInInfo',{params:params})
    },
    submitInpatient(params){
        return post('/app/inpatient/checkIn',params)
    }
}



// WEBPACK FOOTER //
// ./src/service/inpatientRecharge.service.js